module.exports = __webpack_public_path__ + "media/images/mypage/send_btn-e9965982d6cfce88270d68c3df709c5e.png";